module.exports = __webpack_public_path__ + "static/follow-us-fcbdd73f32a938021c96f1189c98a12d.jpg";